module.exports = __webpack_public_path__ + "img/profile-game-controller-active.6d51d847.svg";